import type { SupportedStorage } from '@supabase/supabase-js';
import { AUTH_STORAGE_KEY } from '@/lib/performSignOut';
import { isSignOutStaleAgainstNewerSignIn } from '@/lib/sessionExpiry';

/**
 * Supabase auth storage. `removeItem(clinio-v2-auth)` is how a GoTrue
 * `signOut({ scope: 'local' })` wipes the session — including one a newer
 * sign-in just wrote, and including the copy other tabs read. Refuse that
 * delete when a sign-in epoch is newer than the logout that is still finishing.
 */
export function createGuardedAuthStorage(
  backing: Pick<SupportedStorage, 'getItem' | 'setItem' | 'removeItem'> = localStorage,
): SupportedStorage {
  return {
    getItem: (key) => backing.getItem(key),
    setItem: (key, value) => backing.setItem(key, value),
    removeItem: (key) => {
      if (key === AUTH_STORAGE_KEY && isSignOutStaleAgainstNewerSignIn()) return;
      return backing.removeItem(key);
    },
  };
}
